module.exports = __webpack_public_path__ + "img/congratulation.4613c551.png";